<template>
<div
    v-if="isFooter"
    class="h-full flex justify-center items-center text-main text-md dark:bg-darkCardBg bg-gray-50 font-semibold relative overflow-hidden">
    {{ dataFooter }} <div class="absolute w-full top-0 left-0 h-[2px] bg-main shadow-xl"></div>
</div>
<section v-else>
    <slot name="status"></slot>
    <slot name="state"></slot>
</section>
</template>

<script>
// shared
import shared from './shared';

// naive-ui
import {
    NIcon,
    NButton,
    NPopover } from 'naive-ui';

// icons
import {
    QuestionCircle16Filled } from '@vicons/fluent';

export default {
    name: 'cell-state',
    props: {
        isFooter: {
            type: Boolean,
            default: false,
            required: true,
        },
    },
    components: {
        NIcon,
        NButton,
        NPopover,
        QuestionCircle16Filled,
    },
    setup(props, context) {
        
        return {
            ...shared(props, context),
        };
    },
};
</script>